var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"zt-slider-fade"}},[(_vm.isVisible)?_c('div',{staticClass:"zt-slider-item relative w-full h-full",class:{
    'zt-slide-active': _vm.isVisible,
  }},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }